
import { KeyboardLayouts } from '../../../SimpleKeyboard/Layout';
import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskTextArea } from './KioskTextArea/KioskTextArea';
import { WebTextArea } from './WebTextArea/WebTextArea';
import { TextAreaProps } from './TextArea.types';

const TextArea = ({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    placeholder,
    helperText,
    inputValue,
    error,
    onChangeCallback,
    onFocusCallback,
    onBlurCallback,
}: TextAreaProps) => {
    return isElectron() ? (
        <KioskTextArea
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            placeholder={placeholder}
            helperText={helperText}
            inputValue={inputValue}
            error={error}
            onChangeCallback={onChangeCallback}
            onFocusCallback={onFocusCallback}
            onBlurCallback={onBlurCallback}
        />
    ) : (
        <WebTextArea
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            placeholder={placeholder}
            helperText={helperText}
            inputValue={inputValue}
            onChangeCallback={onChangeCallback}
            onFocusCallback={onFocusCallback}
            onBlurCallback={onBlurCallback}
        />
    );
};

export default TextArea;
